module.exports = __webpack_public_path__ + "static/media/motorcycle.b1165c47.svg";